import { render } from "./ProgressWrapFour.vue?vue&type=template&id=06560c7c&scoped=true"
import script from "./ProgressWrapFour.vue?vue&type=script&lang=js"
export * from "./ProgressWrapFour.vue?vue&type=script&lang=js"

import "./ProgressWrapFour.vue?vue&type=style&index=0&id=06560c7c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06560c7c"]])

export default __exports__